import api from "../../APIIntercepter";

async function getClassTypeAPI() {
  const res = await api.get("/classtype/admin");
  return res.data;
}

async function getClassesAPI() {
  const res = await api.get("/class");
  return res.data;
}

async function getAdminClassesAPI() {
  const res = await api.get("/class/admin/getActiveAndInactiveClasses");
  return res.data;
}

async function createClassAPI(params) {
  const res = await api.post("/class/admin", params);
  return res.data;
}

async function updateClassAPI(params) {
  const res = await api.put("/class/admin", params);
  return res.data;
}

async function deleteClassAPI(classId) {
  const res = await api.delete("/class/admin/" + classId);
  return res.data;
}

async function getScheduleByIdAPI(scheduleId) {
  const res = await api.get("/classSchedule/" + scheduleId);
  return res.data;
}

async function getClassScheduleByClassAPI(classId) {
  const res = await api.get("/classSchedule/admin/geByClassId/" + classId);
  return res.data;
}

async function createClassScheduleAPI(params) {
  const res = await api.post("/classSchedule/admin", params);
  return res.data;
}

async function updateClassScheduleAPI(params) {
  const res = await api.put("/classSchedule/admin", params);
  return res.data;
}

async function deleteClassScheduleAPI(classScheduleId) {
  const res = await api.delete("/classSchedule/admin?id=" + classScheduleId);
  return res.data;
}

export {
  getClassesAPI,
  getAdminClassesAPI,
  createClassAPI,
  updateClassAPI,
  deleteClassAPI,
  getClassScheduleByClassAPI,
  createClassScheduleAPI,
  updateClassScheduleAPI,
  deleteClassScheduleAPI,
  getClassTypeAPI,
  getScheduleByIdAPI
};
